import { render, staticRenderFns } from "./DisplayCouverturesIngredients.vue?vue&type=template&id=025e373d"
import script from "./DisplayCouverturesIngredients.vue?vue&type=script&lang=js"
export * from "./DisplayCouverturesIngredients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports